// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../schema/public';

import { gql } from '@apollo/client';
import { TournamentFragmentDoc } from './TournamentFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TournamentsQueryVariables = Types.Exact<{
  site?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  onlyCurrent?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  onlyFuture?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  onlyPast?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  onlyMy?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  onlyMyWithUnclaimedPrize?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  gameId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  categoryId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  providerId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  excludeTournamentIds?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  orderBy?: Types.InputMaybe<Types.CasinoTournamentsPublicTournamentsQueryOrderBy>;
}>;


export type TournamentsQuery = { __typename?: 'Query', casinoTournamentsPublic?: { __typename?: 'CasinoTournamentsPublic', id?: string, tournaments?: { __typename?: 'CasinoTournamentsPublicTournamentConnection', edges?: Array<{ __typename?: 'CasinoTournamentsPublicTournamentEdge', node?: { __typename?: 'CasinoTournamentsPublicTournament', id: string, enabled?: boolean, openAt?: any, closeAt?: any, iAmOptedIn?: boolean, name?: string, prizeText?: string, activityType?: string, shortUrl?: string, backgroundImageSmall?: string, backgroundImageLarge?: string, rules?: string, leaderboardType?: string, myScore?: { __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean, leaderboardAfter?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }>, leaderboardBefore?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }> }, prizes?: Array<{ __typename?: 'CasinoTournamentsPublicPrize', id: string, forPosition?: number, name?: string, link?: string, isDefaultPrizeBeforeUser?: string, automaticallyReleased?: boolean }>, leaderboard?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }> } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string, hasNextPage: boolean } } } };


export const TournamentsQueryDocument = /*#__PURE__*/ gql`
    query TournamentsQuery($site: String, $first: Int, $last: Int, $after: String, $before: String, $onlyCurrent: Boolean, $onlyFuture: Boolean, $onlyPast: Boolean, $onlyMy: Boolean, $onlyMyWithUnclaimedPrize: Boolean, $gameId: String, $categoryId: String, $providerId: String, $excludeTournamentIds: [String], $orderBy: CasinoTournamentsPublicTournamentsQueryOrderBy) {
  casinoTournamentsPublic {
    id
    tournaments(
      site: $site
      first: $first
      last: $last
      after: $after
      before: $before
      onlyCurrent: $onlyCurrent
      onlyFuture: $onlyFuture
      onlyPast: $onlyPast
      onlyMy: $onlyMy
      onlyMyWithUnclaimedPrize: $onlyMyWithUnclaimedPrize
      gameId: $gameId
      categoryId: $categoryId
      providerId: $providerId
      excludeTournamentIds: $excludeTournamentIds
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...TournamentFragment
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${TournamentFragmentDoc}`;
export function useTournamentsQuery(baseOptions?: Apollo.QueryHookOptions<TournamentsQuery, TournamentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TournamentsQuery, TournamentsQueryVariables>(TournamentsQueryDocument, options);
      }
export function useTournamentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TournamentsQuery, TournamentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TournamentsQuery, TournamentsQueryVariables>(TournamentsQueryDocument, options);
        }
export function useTournamentsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TournamentsQuery, TournamentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TournamentsQuery, TournamentsQueryVariables>(TournamentsQueryDocument, options);
        }
export type TournamentsQueryHookResult = ReturnType<typeof useTournamentsQuery>;
export type TournamentsQueryLazyQueryHookResult = ReturnType<typeof useTournamentsQueryLazyQuery>;
export type TournamentsQuerySuspenseQueryHookResult = ReturnType<typeof useTournamentsQuerySuspenseQuery>;
export type TournamentsQueryQueryResult = Apollo.QueryResult<TournamentsQuery, TournamentsQueryVariables>;